"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIssueIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const CloseIssueIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2688 4.57889L12 6.15385H21C21.5523 6.15385 22 6.60156 22 7.15385V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44772 4 3 4H10.3618C10.751 4 11.1049 4.22585 11.2688 4.57889ZM10.0001 17.4142L17.7072 9.70712L16.293 8.29291L10.0001 14.5858L7.70718 12.2929L6.29297 13.7071L10.0001 17.4142Z" })));
exports.CloseIssueIcon = CloseIssueIcon;
exports.default = exports.CloseIssueIcon;
